import {Component, OnInit, OnDestroy} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MessageService } from '@shared/services/message-service';
import { Site } from '@shared/models/site';
import { SiteSubinventory, SubinventoryType } from '@shared/models/subinventory';
import { ActivityBlockingService } from '@shared/services/activity-blocking.service';
import { Subscription, zip } from 'rxjs';
import { take, tap } from 'rxjs/operators';
import { ShiftContextService } from '../../services/shift-context.service';
import { InventoryService } from '../../services/inventory.service';
import { InvCount } from '../../models/inv-count';
import { ShiftStatus } from '@shared/models/worked-shift';

@Component({
    selector: 'app-inventory',
    templateUrl: './inventory.component.html',
    styleUrls: ['./inventory.component.scss'],
})
export class InventoryComponent implements OnInit, OnDestroy {
    SubinventoryType = SubinventoryType;

    items: MenuItem[];
    activeItem: MenuItem;
    site: Site;
    currentSubinventoryType: SubinventoryType;
    subscriptions: Subscription[];
    startupSubscription: Subscription;
    invCount: InvCount;
    visible = false;

    shiftClosed: boolean = false;

    constructor(
        private inventoryService: InventoryService,
        private shiftContextService: ShiftContextService,
        private activityService: ActivityBlockingService,
        private messageService: MessageService) {}

    ngOnInit(): void {
        this.activeItem = null;
        const siteObservable = this.shiftContextService.CurrentContext.pipe(
            tap((context) => {
                this.shiftClosed = context.status !== ShiftStatus.Open;
                this.site = context.site;
                this.items = [];
                let count = 0;

                const validSubinvs = this.site.subinventories.filter(s => s.isActive);

                if (validSubinvs.length === 0) {
                    this.messageService.add({
                        severity: 'warn',
                        summary: 'No Subinventories configured',
                        detail: 'Please contact PLA Support to have your site properly configured.'
                    });

                    return;
                }

                validSubinvs.forEach((subInventory) => {
                    if (subInventory.name) {
                        const currentCount = count;
                        this.items.push({
                            label: subInventory.name,
                            command: () =>
                                this.activateComponentsPerTab(currentCount, subInventory),
                        });
                        count++;
                    }
                });

                this.activateComponentsPerTab(0, validSubinvs[0]);
            })
        );

        const invCountObservable = this.inventoryService.CurrentInvCountContext.pipe(
            tap((invContext) => {
                if (!!invContext) {
                    this.invCount = invContext;
                }
                else {
                    this.invCount = null;
                }
            }));

        this.subscriptions = [siteObservable.subscribe((_) => {}),
            invCountObservable.subscribe(_ => { })];

        this.startupSubscription = zip(siteObservable,
            invCountObservable)
            .pipe(
                take(1),
                this.activityService.Wait('Daily Production page'))
            .subscribe();
    }

    activateComponentsPerTab(count: number, subInventory: SiteSubinventory): void {
        if (!!subInventory) {
            this.inventoryService.updateActiveSection(subInventory).subscribe(() => {
                this.activeItem = this.items[count];
                this.currentSubinventoryType = subInventory.subinventoryType;
            });
        }
    }

    CopyPreviousShift(subinventoryId: number): void {
        this.inventoryService.copyPreviousCount(subinventoryId, this.invCount.id);
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
